/* eslint-disable jsx-a11y/tabindex-no-positive */
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import storage from '../../utils/storage';

export default function LoginWithMagicLink() {
  const [pathname, setPathname] = useState('');

  // init user if logged in
  useEffect(() => {
    // Support both ?query and #hash?query styles
    const params = new URLSearchParams(window.location.search || window.location.hash.replace(/^#\??/, ''));
    const token = params.get('access_token');
    const refreshToken = params.get('refresh_token');
    // default to true if not provided (so long sessions work out of the box)
    const rememberMe = (params.get('remember_me') ?? 'true') === 'true';
    const path = params.get('path');

    if (token) {
      storage.set('token', token);
      storage.set('refreshToken', refreshToken);
      storage.set('rememberMe', rememberMe);
    }

    setPathname(path || '/');
  }, []);

  if (!pathname) {
    return null;
  }

  return <Redirect to={pathname} />;
}
